<template>
    <div class="produce-list">
        <div>
            <div class="container">
                <div class="title" v-if="leftTitle != ''">
                    {{ leftTitle }}<span class="red">.</span>
                </div>


                <!-- 搜索栏目 -->
                <div class="search-section">
                    <div class="search-container">
                        <el-input v-model="searchKeyword" placeholder="Search brochures by keyword..."
                            class="search-input" @keyup.enter="handleSearch" clearable>
                            <template #append>
                                <el-button type="primary" icon="el-icon-search" @click="handleSearch"
                                    class="search-button">
                                    Search
                                </el-button>
                            </template>
                        </el-input>
                        <el-button type="text" @click="clearSearch" class="clear-search" v-if="searchKeyword">
                            Clear
                        </el-button>
                    </div>
                </div>
                <div class="main">
                    <div class="catalogueTree">
                        <!-- 左侧分类栏 -->
                        <div class="category">
                            <div class="title" @click="changeCategoryFold">
                                CATEGORY
                                <i class="el-icon-minus fold" v-if="!foldCategory"></i>
                                <i class="el-icon-plus unfold" v-else></i>
                            </div>
                            <div class="content" v-if="!foldCategory">
                                <div class="categoryItem" v-for="item in categoryList" :key="item.id"
                                    :class="{ active: selectedCategoryId === item.id }" @click="selectCategory(item)">
                                    <span class="name">{{ item.name }}</span>
                                    <!-- <span class="num">({{ item.product_count || 0 }})</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-loading="loading" class="BrochureList">
                        <!--顶部的排序及分页-->
                        <div class="listinfo">
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <div class="totalNum">{{ results }} results</div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <el-select v-model="changeProductData.pageSize" placeholder="请选择" size="mini"
                                        style="float: left; width: 102px; margin-left: 10px" @change="changeShowNum"
                                        class="num-select">
                                        <el-option v-for="item in options2" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                        :current-page="changeProductData.page" :page-size="changeProductData.pageSize"
                                        :pager-count="5" :total="results" layout=" prev, pager, next,jumper">
                                    </el-pagination>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="product-content">
                            <div class="gridViewProductItem" v-for="item in BrochureList" :key="item.id">
                                <div class="img" @click="toPdfView(item.preview_url)">
                                    <img v-lazy="item.image" alt="" />
                                </div>
                                <div class="name" @click="toPdfView(item.preview_url)">
                                    <span> {{ item.title }} </span>
                                </div>
                                <!-- <div class="index">Item # {{ item.code }}</div> -->
                                <!-- <div class="price">
                                    {{ currency_symbol }}{{ item.min_price }} - {{ currency_symbol }}{{ item.max_price
                                    }}
                                </div> -->
                                <!-- <div class="qty">MIN QTY: {{ item.min_quantity }}</div> -->
                            </div>
                        </div>

                        <el-pagination style="margin-top: 80px; text-align: right; width: 100%"
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="changeProductData.page" :page-size="changeProductData.pageSize"
                            :total="results" layout="total, prev, pager, next,jumper" :pager-count="5">
                        </el-pagination>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BrochureList, BrochureCateList } from "@/api/brochure";

export default {
    data() {
        return {
            loading: false,
            results: 0,
            currency_symbol: '$',
            foldCategory: false, // 分类栏折叠状态
            categoryList: [], // 分类列表数据
            selectedCategoryId: "", // 当前选中的分类ID
            searchKeyword: "", // 搜索关键词
            changeProductData: {
                page: 1,
                pageSize: 30,
                order: "update_time desc",
                category_id: "",
                theme_id: "",
                keyword: "",
                token: "",
                is_rush: 0,
                price_type: "",
                is_sg: 1
            },

            options2: [
                {
                    value: "30",
                    label: "Show 30",
                },
                {
                    value: "60",
                    label: "Show 60",
                },
                {
                    value: "120",
                    label: "Show 120",
                },
               
            ],
            BrochureList: [],
            leftTitle: "All brochures",
        };
    },
    mounted() {
        this.getBrochureList();
        this.getCategoryData(); // 获取分类数据
    },
    methods: {
        toPdfView(url) {
            window.open(url, '_blank');
        },
        handleSizeChange(val) {
            this.changeProductData.pageSize = val;
            this.getBrochureList();
        },
        handleCurrentChange(val) {
            this.changeProductData.page = val;
            this.getBrochureList();
        },
        changeShowNum(val) {
            this.changeProductData.pageSize = val;
            this.getBrochureList();
        },
        changeOrder(val) {
            this.getBrochureList();
        },
        // 切换分类栏折叠状态
        changeCategoryFold() {
            this.foldCategory = !this.foldCategory;
        },
        // 选择分类
        selectCategory(item) {
            this.selectedCategoryId = item.id;
            this.changeProductData.category_id = item.id;
            this.getBrochureList();
            console.log(item, 'item');
        },
        getBrochureList() {
            this.loading = true;
            BrochureList(this.changeProductData).then((res) => {
                this.BrochureList = res.data.data;
                this.currency_symbol = 1;
                this.results = res.data.total;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        // 获取分类数据（这里需要根据实际情况实现）
        getCategoryData() {
            this.loading = true;
            BrochureCateList().then((res) => {
                console.log(res, 'res');
                this.categoryList = res.data;
            }).catch(() => {
                this.loading = false;
            });
        },
        // 处理搜索
        handleSearch() {
            this.changeProductData.keyword = this.searchKeyword.trim();
            this.changeProductData.page = 1; // 搜索时重置到第一页
            this.getBrochureList();
        },

        // 清除搜索
        clearSearch() {
            this.searchKeyword = "";
            this.changeProductData.keyword = "";
            this.changeProductData.page = 1;
            this.getBrochureList();
        },

    },
};
</script>

<style scoped>
/* 搜索栏目样式 */
.search-section {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end; /* 居右对齐 */
}

.search-container {
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 400px;
    width: 100%;
    justify-content: flex-end; /* 容器内元素居右 */
}

.search-input {
    flex: 1;
    max-width: 300px;
}

.search-button {
    background: #38a7bb;
    border-color: #38a7bb;
    color: white;
}

/* .search-button:hover {
    background: #66b1ff;
    border-color: #66b1ff;
} */

.clear-search {
    color: #666;
    font-size: 14px;
    padding: 0 8px;
}

.clear-search:hover {
    color: #409EFF;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .search-section {
        justify-content: center; /* 移动端居中 */
    }
    
    .search-container {
        flex-direction: column;
        align-items: stretch;
        max-width: 100%;
    }

    .clear-search {
        align-self: flex-end;
        margin-top: 10px;
    }
}

/* .clear-search:hover {
    color: #409EFF;
} */

/* 左侧分类栏统一样式 */
.catalogueTree {
    flex: 0 0 auto;
    max-width: 100%;
    position: sticky;
    top: 60px;
    background-color: white;
    max-height: calc(100vh - 230px);
    margin-right: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.category {
    margin-top: 0;
    border: none;
    width: 240px;
}

.category .title {
    padding: 16px 20px;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.category .title:hover {
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
}

.category .title .fold, .category .title .unfold {
    color: white;
    font-size: 14px;
    transition: transform 0.3s ease;
}

.category .title:hover .fold, .category .title:hover .unfold {
    transform: scale(1.1);
}

.category .content {
    max-height: 300px;
    overflow-y: auto;
    padding: 10px 0;
    background: white;
}

.category .content::-webkit-scrollbar {
    width: 6px;
}

.category .content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.category .content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.category .content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.categoryItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
    margin: 2px 0;
    border-radius: 0;
    position: relative;
}

.categoryItem:hover {
    background-color: #f8faff;
    border-left-color: #409EFF;
    transform: translateX(2px);
}

.categoryItem.active {
    background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
    border-left-color: #409EFF;
    color: #1890ff;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px rgba(64, 158, 255, 0.1);
}

.categoryItem.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #409EFF;
    border-radius: 0 2px 2px 0;
}

.categoryItem .name {
    flex: 1;
    font-size: 14px;
    color: #333;
    transition: color 0.3s ease;
}

.categoryItem:hover .name {
    color: #409EFF;
}

.categoryItem.active .name {
    color: #1890ff;
}

.categoryItem .num {
    font-size: 12px;
    color: #999;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 10px;
    min-width: 30px;
    text-align: center;
    transition: all 0.3s ease;
}

.categoryItem:hover .num {
    background: #e6f7ff;
    color: #409EFF;
}

.categoryItem.active .num {
    background: #1890ff;
    color: white;
}

/* 分类栏空状态 */
.category .content:empty::before {
    content: 'No categories available';
    display: block;
    text-align: center;
    color: #999;
    font-size: 14px;
    padding: 20px;
    font-style: italic;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .search-container {
        flex-direction: column;
        align-items: stretch;
    }

    .clear-search {
        align-self: flex-end;
        margin-top: 10px;
    }

    .catalogueTree {
        position: static;
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
        max-height: none;
    }

    .category {
        width: 100%;
    }

    .category .title {
        padding: 14px 16px;
        font-size: 15px;
    }

    .categoryItem {
        padding: 10px 16px;
    }
}

/* 保留必要的样式，删除不必要的样式 */
.produce-list {
    min-height: 100vh;
    background: #f5f5f5;
}

.container {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.red {
    color: #ff0000;
}

.main {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
}

.BrochureList {
    flex: 1;
    min-width: 0;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.listinfo {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
}

.totalNum {
    font-size: 16px;
    color: #666;
    margin-bottom: 15px;
}

.product-content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.gridViewProductItem {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 15px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.gridViewProductItem:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.gridViewProductItem .img {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 10px;
}

.gridViewProductItem .img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gridViewProductItem .name {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.gridViewProductItem .name:hover {
    color: #409EFF;
}

.gridViewProductItem .index {
    font-size: 12px;
    color: #999;
    margin-bottom: 5px;
}

.gridViewProductItem .price {
    font-size: 16px;
    color: #e4393c;
    font-weight: bold;
    margin-bottom: 5px;
}

.gridViewProductItem .qty {
    font-size: 12px;
    color: #666;
}

/* 分页样式 */
.el-pagination {
    margin-top: 30px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .container {
        width: 100%;
        padding: 10px;
    }

    .main {
        flex-direction: column;
    }

    .product-content {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
    }

    .gridViewProductItem {
        padding: 10px;
    }

    .gridViewProductItem .img {
        height: 150px;
    }
}
</style>
